import { useFetchClient } from '@strapi/strapi/admin';
import { PLUGIN_API_PREFIX } from '../pluginId';

export interface EmailTemplate {
  id?: number;
  documentId?: string;
  name: string;
  subject: string;
  designJson?: unknown;
  htmlBody?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface EmailTemplateListItem {
  id: number;
  documentId: string;
  name: string;
  subject: string;
  updatedAt: string;
  createdAt: string;
}

export interface SendPayload {
  to: string | string[];
  data?: Record<string, unknown>;
  cc?: string | string[];
  bcc?: string | string[];
  from?: string;
  replyTo?: string;
}

const ROOT = `${PLUGIN_API_PREFIX}/templates`;

export interface StarterTemplate {
  id: string;
  subject: string;
  content: any;
}

export const useTemplatesApi = () => {
  const { get, post, put, del } = useFetchClient();

  return {
    list: () => get<{ data: EmailTemplateListItem[] }>(ROOT).then((r) => r.data),
    getOne: (id: string) => get<{ data: EmailTemplate }>(`${ROOT}/${id}`).then((r) => r.data),
    create: (payload: EmailTemplate) =>
      post<{ data: EmailTemplate }>(ROOT, { data: payload }).then((r) => r.data),
    update: (id: string, payload: EmailTemplate) =>
      put<{ data: EmailTemplate }>(`${ROOT}/${id}`, { data: payload }).then((r) => r.data),
    remove: (id: string) => del(`${ROOT}/${id}`),
    send: (id: string, payload: SendPayload) =>
      post<{ data: unknown }>(`${ROOT}/${id}/send`, { data: payload }).then((r) => r.data),
    listStarters: () =>
      get<{ data: StarterTemplate[] }>(`${PLUGIN_API_PREFIX}/starters`).then((r) => r.data),
  };
};
